import {
  GET_CLIENTS_REQUEST,
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_FAILURE,
  GET_CLIENT_BY_RUT_REQUEST,
  GET_CLIENT_BY_RUT_SUCCESS,
  GET_CLIENT_BY_RUT_FAILURE,
  GET_CLIENT_PORTAL,
  GET_CLIENT_PORTAL_SUCCESS,
  GET_CLIENT_PORTAL_FAILURE,
  CREATE_CLIENT,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  UPDATE_CLIENT_PASSWORD,
  UPDATE_CLIENT_PASSWORD_SUCCESS,
  UPDATE_CLIENT_PASSWORD_FAILURE,
  GET_CLIENT_EXISTS,
  GET_CLIENT_EXISTS_SUCCESS,
  GET_CLIENT_EXISTS_FAILURE
} from '../../api/Types';

const initialState = {
  collection: [],
  entry: {},
  client: {},
  getting: false,
  loading: false,
  count: 0,
  limit: 10,
  //nuevos campos
  exists: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        collection: action.payload.body,
        count: Number(action.payload.count),
        limit: action.payload.limit,
        loading: false,
      };
    case GET_CLIENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_CLIENT_BY_RUT_REQUEST:
      return {
        ...state,
        getting: true,
      };
    case GET_CLIENT_BY_RUT_SUCCESS:
      return {
        ...state,
        entry: action.body,
        getting: false,
      };
    case GET_CLIENT_BY_RUT_FAILURE:
      return {
        ...state,
        getting: false,
        error: action.error,
      };
    case CREATE_CLIENT:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case UPDATE_CLIENT_PASSWORD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CLIENT_PASSWORD_SUCCESS:
      return {
        ...state,
        entry: action.body,
        loading: false,
      };
    case UPDATE_CLIENT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_CLIENT_EXISTS:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENT_EXISTS_SUCCESS:
      return {
        ...state,
        exists: action.body,
        loading: false,
      };
    case GET_CLIENT_EXISTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_CLIENT_PORTAL:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENT_PORTAL_SUCCESS:
      return {
        ...state,
        client: action.body,
        loading: false,
      };
    case GET_CLIENT_PORTAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
